export default "__VITE_ASSET__1941eca9__"